import FormListComposer from '../../../composers/FormListComposer';

export default function FormListPage(): JSX.Element {
  return <FormListComposer />;
}
